import React from 'react';
interface CTAButtonProps {
  href: string;
  text: string;
  className?: string;
}
export function CTAButton({
  href,
  text,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`block w-full max-w-md mx-auto bg-[#D4A853] hover:bg-[#B8935C] text-[#1B4332] font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-sm text-center cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] ${className}`} data-id="element-442">
      {text}
    </a>;
}